import type { FaireProductEntity } from "../../entity_types/product";

export const p_ddfj64dd8m: FaireProductEntity = {
  token: "p_ddfj64dd8m",
  type: "product",
  name: "The Sugar Plum Social Mahj Mat©",
  brandToken: "b_r56bdd4kh8",
  brandName: "Nash Grey",
  imageUrl:
    "https://cdn.faire.com/fastly/2567913b340d721022d9eb41d7d8f1b852e4ea01f7b50cea92c29e589a8fb1a2.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d9e93470199addaf6b0749cfd1f5531cb155109e0cf65832e18728fcb8a93ae4.png",
  ],
  priceDollars: 34,
  description:
    'Elevate your holiday tile nights with the ultimate blend of festive charm and modern style. Designed exclusively for Nash Grey, this gorgeous pink Mahjong mat features an original, copyrighted holiday illustration complete with whimsical nutcrackers, delicate gingham-style bows, and starry ornaments. Whether you\'re hosting a cozy winter game night or gifting the ultimate Mahjong enthusiast, this aesthetic mat brings a touch of "coquette-chic" luxury to every table.\n\n33" x 33" x 0.12"\n\nPlease note that this photo is a digital mock up, actual design/colors may vary slightly.\n\nETA is the estimated time of arrival to us - please be mindful that these are estimated arrival dates and we do not guarantee any items by a specific date. Unfortunately, shipping and production delays sometimes occur and are out of our control.\n',
  tags: [],
  msrpDollars: 68,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:41.338Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
